
import {
    onMounted,
    ref,
    defineAsyncComponent,
} from 'vue'; 

import numeral from 'numeral';

import useProductos from '@/modules/ventas/composables/useProductos';

export default {
    components: {
        ProductoStockEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/ProductoStockEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerProductosStock,
        } = useProductos();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Código', value: 'codigo_barras', sortable: true, },
            { text: 'Nombre', value: 'nombre', sortable: true, },
            { text: 'P/Compra', value: 'precio_compra', sortable: true, },
            { text: 'P/Venta', value: 'precio_venta', sortable: true, },
            { text: 'P/Venta por mayor', value: 'precio_venta_por_mayor', sortable: true, },
            { text: 'Stock', value: 'stock', sortable: true, },
            { text: 'Stock mínimo', value: 'stock_minimo', sortable: true, },
            { text: 'Categoría', value: 'nombre_categoria', sortable: true, },
            { text: 'Marca', value: 'nombre_marca', sortable: true, },
            { text: 'Presentación', value: 'nombre_presentacion', sortable: true, },
            { text: 'Estado', value: 'estado', sortable: true, },
            { text: '', value: 'acciones', width: 15, },
        ];

        let productos: any = [];
        const productosFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const productoStockEditarComponentRef = ref();

        let productosArrayIds: any = [];
        let productosIds: any = [];

        onMounted(async() => {
            await buscarProductos();
        });

        const buscarProductos = async () => {
            const resp = await obtenerProductosStock(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                productos = resp.data;
                productosFiltrados.value = JSON.parse(JSON.stringify(productos));
            }

            // Para eliminar los productos que ya fueron stockeados.
            const respProductosIds = await obtenerProductosStock('');
            productosIds = [];
            if (respProductosIds.ok) {
                productosArrayIds = respProductosIds.data;
                productosArrayIds.forEach((p: any) => {
                    productosIds.push(p.id_producto); 
                });
            }
        }

        const nuevoProducto = async () => {
            productoStockEditarComponentRef.value.abrirComponent(undefined, productosIds, true);
        }

        const editarProducto = async (producto: any) => {
            productoStockEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(producto)), productosIds, false);
        }

        const filtrarInformacion = async () => {
            productosFiltrados.value = JSON.parse(JSON.stringify(
                productos.filter(
                    (u: any) => u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.codigo_barras.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_categoria.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_marca.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_presentacion.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarProductoStockComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarProductos();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            productosFiltrados,

            buscarProductos,
            editarProducto,
            filtrarInformacion,
            nuevoProducto,

            numeral,

            productoStockEditarComponentRef,
            cerrarEditarProductoStockComponentEmit,
        };
    }
}
